import { ApiOption } from '../../_foundation/models/base.models';
import { PtLuxonDate } from '../projects/date.models';
import { DailyLogOperationInstance, DailyLogType } from '../projects/operation.models';

export class SetupMetadata {
  projectOptions: ProjectSetupOption[];
}

export class VesselMetadata {
  vesselOptions: VesselOption[];
}

export class ProjectSetupOption extends ApiOption<number> {
  ordinal: number;
  phaseOptions: PhaseSetupOption[] = [];
}

export class PhaseSetupOption extends ApiOption<number> {
  ordinal: number;
  stageOptions: StageOption[] = [];
}

export class StageOption extends ApiOption<number> {
  ordinal: number;
  locationOptions: LocationOption[] = [];
}

export class LocationOption extends ApiOption<number> {
}

export class VesselOption extends ApiOption<number> {
  vesselClassId: number;
  vesselName: string;
  wind1RecordedAt: number;
  wind1RecordedAtLabel: string;
  wind2RecordedAt: number;
  wind2RecordedAtLabel: string;
  tracksUreaUsage: boolean;
  isNonJacking: boolean;
  legsCount?: number;
}

export interface SetupSummary {
  project: ProjectSetupOption;
  phase: PhaseSetupOption;
  stage: StageOption;
  location: LocationOption;
}

export class UpdatedSetupSummary {
  projectName: string;
  projectId: number;
  projectTimeChanged: PtLuxonDate;
  projectClientName: string;

  phaseName: string;
  phaseId: number;
  phaseTimeChanged: PtLuxonDate;

  stageName: string;
  stageId: number;
  stageTimeChanged: PtLuxonDate;

  locationName: string;
  locationId: number;
  locationTimeChanged: PtLuxonDate;
  // used for the external library ionic-selectable - as it needs an object not an id for the ngModel
  selectedLocation: LocationOption;

  transitingLocationName: string;
  transitingLocationId: number;
  transitingTimeChanged: PtLuxonDate;

  // will be true where the transit operation sub-classification is Jacking
  transitOperationIsJacking?: boolean;
  jackingLocationName: string;
  jackingLocationId: number;

  vesselMasterName: string;
  vesselMasterTimeChanged: PtLuxonDate;

  clientRepName: string;
  clientRepTitle: string;
  otherRepName: string;
  otherRepTitle: string;

  vesselName: string;

  cycleOrdinal?: number;
}

export class ProjectSelectOptions {
  options = {
    title: 'Projects',
    subTitle: 'Select a Project',
    mode: 'md'
  };
}

export class PhaseSelectOptions {
  options = {
    title: 'Phases',
    subTitle: 'Select a Phase',
    mode: 'md'
  };
}

export class StageSelectOptions {
  options = {
    title: 'Stages',
    subTitle: 'Select a Stage',
    mode: 'md'
  };
}

export class LocationSelectOptions {
  options = {
    title: 'Locations',
    subTitle: 'Select a Location',
    mode: 'md'
  };
}

export class VesselSelectOptions {
  options = {
    title: 'Vessels',
    subTitle: 'Select a Vessel',
    mode: 'md'
  };
}

export class UserSelectOptions {
  options = {
    title: 'Users',
    subTitle: 'List of known users',
    mode: 'md'
  };
}

export class SetupChangeLogRecord {
  id: number;
  batchId: string;
  changeType: SetupChangeType;
  changeTypeId: SetupChangeType;
  previousValue?: string;
  previousValueId?: number;
  newValue: string;
  newValueId: number;
  timeOfChange: PtLuxonDate;
  timeOfChangeOffset: number;
  timeOfChangeToShow: string;
  dailyLogRecordId: number;
  transitEntityId?: number;

  // local variables
  localId?: number;
  localDailyLogRecordId?: number;
  startingTransit?: boolean;

  // used in the ionic-selectable dropdown - because this library only uses an object as ngModel, not the id
  selectedLocation?: LocationOption;
}

export class StageStartAndEnd {
  stageId: number;
  startTime: PtLuxonDate;
  endTime: PtLuxonDate;
}

export enum SetupChangeType {
  ProjectChange = 1,
  PhaseChange = 2,
  StageChange = 3,
  LocationChange = 4,
  VesselMasterChange = 5,
  Transiting = 6,
  ClientRepChange = 7,
  ClientRepTitleChange = 8,
  OtherRepChange = 9,
  OtherRepTitleChange = 10
}

export class LocationChangeEditor {
  classification: string;
  previousName: string;
  newName: string;
  id: number;
  uniqueOrdinal: number;
  type: DailyLogType;
  operationInstance: DailyLogOperationInstance;
}

export enum VesselClasses {
  NG5500X = 1,
  NG2500X = 2,
  NG14000X = 3,
  M = 4
}

export class SetupChangeDeleteValidationResult {
  canDeleteSetupChange: boolean;
  warnings: string[];
  errors: string[];
}

export class LocationSummary {
  id: number;
  name: string;
  typeId: number;
}



// WEBPACK FOOTER //
// ./src/models/setup/setup.models.ts